import script from "./MCQ.vue?vue&type=script&lang=ts&setup=true"
export * from "./MCQ.vue?vue&type=script&lang=ts&setup=true"

import "./MCQ.vue?vue&type=style&index=0&id=42a4cb26&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a4cb26"]])

export default __exports__